export default __webpack_public_path__ + "static/media/information.94c3f962.svg";